import { DomainSerializer } from '../../global/serializables/domain.serializer';
import { ContaTev } from '../domain/conta-tev.model';
export class ContaTevSerializer extends DomainSerializer<ContaTev> {}